export class IncomeRent{
    hmy:number;
    resSSI?:number;
    monthlyGross:number;
    monthlyRent:number;
    monthlyUtility:number;
    renting?:number;
}